import { render, staticRenderFns } from "./ShareCoupons.vue?vue&type=template&id=b96c8cc4&scoped=true"
import script from "./ShareCoupons.vue?vue&type=script&lang=ts"
export * from "./ShareCoupons.vue?vue&type=script&lang=ts"
import style0 from "./ShareCoupons.vue?vue&type=style&index=0&id=b96c8cc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96c8cc4",
  null
  
)

export default component.exports